import {Link} from "react-router";

import FormErrorAlerts from "@/components/form/FormErrorAlerts.tsx";
import {ActionDialog} from "@/components/overlay/ActionDialog.tsx";
import {BillingPeriod} from "@/lib/types/billing.ts";
import {UpsellAlert} from "@/pages/billing/components/UpsellAlert.tsx";
import {Tier} from "@/pages/billing/v2/InstantCheckout/components/Tier.tsx";
import {SubscriptionPackTier} from "@/pages/billing/v2/types.ts";

export interface InstantCheckoutReasonAlert {
  callout: string;
  body: string;
}

export interface InstantCheckoutPopupProps {
  currentTier?: SubscriptionPackTier;
  nextTier?: SubscriptionPackTier;
  lines: string[];
  show: boolean;
  onCancel: () => void;
  onCustomize?: () => void;
  onConfirm: () => void;
  titleMessage: string;
  reasonAlerts: InstantCheckoutReasonAlert[];
  includeContactMessage: boolean;
  btnTitle: string;
  billingPeriod?: BillingPeriod;
  loading: boolean;
  errors: string[];
  disableConfirmButton: boolean;
  hasSubscription: boolean;
  showTierLimits?: boolean;
}

export const InstantCheckoutPopup = ({
  currentTier,
  nextTier,
  billingPeriod,
  lines,
  onConfirm,
  onCustomize,
  onCancel,
  show,
  titleMessage,
  reasonAlerts,
  includeContactMessage,
  btnTitle,
  loading,
  errors,
  disableConfirmButton,
  hasSubscription,
  showTierLimits = true,
}: InstantCheckoutPopupProps) => {
  return (
    <ActionDialog
      show={show}
      confirmBtnText={btnTitle}
      hasCancelButton={false}
      onCancel={onCancel}
      onConfirm={onConfirm}
      onSecondaryAction={onCustomize}
      secondaryBtnText={onCustomize ? "Customize Subscription" : undefined}
      size={"lg"}
      loading={loading}
      titleClassName="text-center w-100 py-3 pulseTextH1Bold pulse-color-gray-800"
      title={titleMessage}
      disableConfirmButton={disableConfirmButton}
      centered
      showBorders
    >
      <div className="p-2">
        <FormErrorAlerts errors={errors}></FormErrorAlerts>
        {reasonAlerts.map((alert, index) => (
          <UpsellAlert
            key={index}
            title={alert.callout}
            alertVariant={!disableConfirmButton ? "error" : "verification"}
            dismissable={false}
          >
            {alert.body}
            {index === 0 && includeContactMessage && (
              <>
                {" "}
                If you have any questions don't hesitate to{" "}
                <Link to={"/contact"} target="_blank">
                  contact us
                </Link>
                .
              </>
            )}
          </UpsellAlert>
        ))}
        <div className="row">
          {currentTier && (
            <div className="col">
              <Tier
                tier={currentTier}
                billingPeriod={billingPeriod}
                subtitle={"Current Plan"}
                active={false}
                showTierLimits={showTierLimits}
              />
            </div>
          )}
          <div className="col">
            {nextTier && (
              <Tier
                tier={nextTier}
                billingPeriod={billingPeriod}
                subtitle={hasSubscription ? "Upgrade to" : "Starting At"}
                lines={currentTier ? [] : lines}
                active={true}
                showTierLimits={showTierLimits}
              />
            )}
          </div>
        </div>
      </div>
    </ActionDialog>
  );
};
